export const Values = {
  "TABLE_NAME_RESPONSES": "Responses",
  "TABLE_NAME_REQUEST_PARAMETERS": "requestParameters",
  "TABLE_NAME_BODY_PARAMETER": "bodyParameter",
  "TABLE_NAME_PROPERTIES": "properties",
  "TABLE_HEADER_SCHEMA": "schema",
  "TABLE_HEADER_NAME": "Name",
  "TABLE_HEADER_TYPE": "Type",
  "TYPE_OBJECT": "object",
  "TYPE_ARRAY": "array",
  "TYPE_UNDEFINED": "undefined",
  "PROPERTIES": "properties",
  "VIEW_DOCUMENTATION": "View Documentation",
  "SINGLE_API": "Single API",
};

export const SeoTitles = {
  "title": "Phenom API Documentation |  List of Phenom API | Phenom Developer API's",
  "Jobs": "Phenom Job API | Job Search API | Phenom Developer API's",
  "Candidates": "Phenom Candidate API | Candidate API | Phenom Developer API's",
  "Employees": "Phenom Employees API | Employees API | Phenom Developer API's",
  "Applications": "Phenom Application API | Applications API | Phenom Developer API's",
  "Applicants": "Phenom Applicants API | Applicants API | Phenom Developer API's",
  "AI Matching": "Phenom AI Matching API | AI Matching API API | Phenom Developer API's",
  "Parsers": "Phenom Parsers API | Resume Parsing API | Phenom Developer API's",
  "Communications": "Phenom Communications API | Communications API | Phenom Developer API's",
  "Campaigns": "Phenom Campaigns API | Campaigns API | Phenom Developer API's",
  "User Management": "Phenom User Management API | User Management API | Phenom Developer API's",
  "Tags": "Phenom Tags API | Tags API | Phenom Developer API's",
  "Projects": "Phenom Projects API | Projects API | Phenom Developer API's",
  "Prediction": "Phenom Prediction API | Prediction API | Phenom Developer API's",
  "Hiring Manager": "Phenom Hiring Manager API | Hiring Manager API | Phenom Developer API's",
  "Evaluations": "Phenom Evaluations API | Evaluations API | Phenom Developer API's",
  "Interview Screening": "Phenom Interview Screening API | Interview Screening API | Phenom Developer API's",
};


